<template>
    <div class="conductores-form">
        <div class="form-header">
            <span class="form-title h2">
                <i class="fa-solid fa-id-card"></i>
                Conductores
            </span>
            <b-button variant="primary" size="sm" @click="collapsed = !collapsed" class="toggle-btn">
                <i :class="collapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
            </b-button>
        </div>

        <b-collapse v-model="collapsed" class="mt-3">
            <b-card class="shadow-sm border-0 bg-dark">
                <b-form @submit.prevent="registrarConductores" novalidate>

                    <!-- Datos conductor principal -->
                    <h5 class="text-white mb-3">Conductor Principal</h5>
                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Tipo Identificación" label-for="tipoIdentificacionPrincipal">
                                <b-form-input id="tipoIdentificacionPrincipal"
                                    v-model="form.tipoIdentificacionPrincipal" placeholder="Ej: 1" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Número Identificación" label-for="numeroIdentificacion">
                                <b-form-input id="numeroIdentificacion" v-model="form.numeroIdentificacion"
                                    placeholder="Ej: 79456854" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Primer Nombre" label-for="primerNombrePrincipal">
                                <b-form-input id="primerNombrePrincipal" v-model="form.primerNombrePrincipal"
                                    placeholder="Ej: Carlos" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Segundo Nombre" label-for="segundoNombrePrincipal">
                                <b-form-input id="segundoNombrePrincipal" v-model="form.segundoNombrePrincipal"
                                    placeholder="Ej: Eduardo" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Primer Apellido" label-for="primerApellidoPrincipal">
                                <b-form-input id="primerApellidoPrincipal" v-model="form.primerApellidoPrincipal"
                                    placeholder="Ej: Gómez" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Segundo Apellido" label-for="segundoApellidoPrincipal">
                                <b-form-input id="segundoApellidoPrincipal" v-model="form.segundoApellidoPrincipal"
                                    placeholder="Ej: Ríos" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="4">
                            <b-form-group label="Licencia Conducción" label-for="licenciaConduccion">
                                <b-form-input id="licenciaConduccion" v-model="form.licenciaConduccion"
                                    placeholder="Ej: 111245325" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <b-form-group label="ID Prueba Alcoholimetría" label-for="idPruebaAlcoholimetria">
                                <b-form-input id="idPruebaAlcoholimetria" v-model="form.idPruebaAlcoholimetria"
                                    placeholder="Ej: 6035" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <b-form-group label="ID Examen Médico" label-for="idExamenMedico">
                                <b-form-input id="idExamenMedico" v-model="form.idExamenMedico" placeholder="Ej: 8026"
                                    required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Datos conductor secundario -->
                    <h5 class="text-white mb-3 mt-4">Conductor Secundario</h5>
                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Tipo Identificación" label-for="tipoIdentificacionSecundario">
                                <b-form-input id="tipoIdentificacionSecundario"
                                    v-model="form.tipoIdentificacionSecundario" placeholder="Ej: 2" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Número Identificación" label-for="numeroIdentificacionSecundario">
                                <b-form-input id="numeroIdentificacionSecundario"
                                    v-model="form.numeroIdentificacionSecundario" placeholder="Ej: 1012456857"
                                    required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Primer Nombre" label-for="primerNombreSecundario">
                                <b-form-input id="primerNombreSecundario" v-model="form.primerNombreSecundario"
                                    placeholder="Ej: Luis" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Segundo Nombre" label-for="segundoNombreSecundario">
                                <b-form-input id="segundoNombreSecundario" v-model="form.segundoNombreSecundario"
                                    placeholder="Ej: Alberto" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Primer Apellido" label-for="primerApellidoSecundario">
                                <b-form-input id="primerApellidoSecundario" v-model="form.primerApellidoSecundario"
                                    placeholder="Ej: Martínez" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Segundo Apellido" label-for="segundoApellidoSecundario">
                                <b-form-input id="segundoApellidoSecundario" v-model="form.segundoApellidoSecundario"
                                    placeholder="Ej: Pérez" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="4">
                            <b-form-group label="Licencia Conducción" label-for="licenciaConduccionSecundario">
                                <b-form-input id="licenciaConduccionSecundario"
                                    v-model="form.licenciaConduccionSecundario" placeholder="Ej: 111125216" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <b-form-group label="ID Prueba Alcoholimetría" label-for="idPruebaAlcoholimetriaSecundario">
                                <b-form-input id="idPruebaAlcoholimetriaSecundario"
                                    v-model="form.idPruebaAlcoholimetriaSecundario" placeholder="Ej: 6036" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <b-form-group label="ID Examen Médico" label-for="idExamenMedicoSecundario">
                                <b-form-input id="idExamenMedicoSecundario" v-model="form.idExamenMedicoSecundario"
                                    placeholder="Ej: 8027" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <div class="d-flex justify-content-end pt-3">
                        <b-button type="submit" variant="primary" size="lg" :disabled="loading" class="btn-submit">
                            <b-spinner v-if="loading" small class="mr-2"></b-spinner>
                            <i v-else class="fa-solid fa-floppy-disk mr-2"></i>
                            {{ loading ? 'Guardando...' : 'Guardar Conductores' }}
                        </b-button>
                    </div>

                </b-form>
            </b-card>
        </b-collapse>
    </div>
</template>




<script>
export default {
    name: 'FormularioConductores',
    data() {
        return {
            loading: false,
            collapsed: true,
            form: {
                tipoIdentificacionPrincipal: '',
                numeroIdentificacion: '',
                primerNombrePrincipal: '',
                segundoNombrePrincipal: '',
                primerApellidoPrincipal: '',
                segundoApellidoPrincipal: '',
                licenciaConduccion: '',
                idPruebaAlcoholimetria: '',
                idExamenMedico: '',
                tipoIdentificacionSecundario: '',
                numeroIdentificacionSecundario: '',
                primerNombreSecundario: '',
                segundoNombreSecundario: '',
                primerApellidoSecundario: '',
                segundoApellidoSecundario: '',
                licenciaConduccionSecundario: '',
                idPruebaAlcoholimetriaSecundario: '',
                idExamenMedicoSecundario: '',
            }
        }
    },
    props: {
        preCarga: {
            type: Object,
            default: null

        }
    },
    watch: {
        preCarga: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.form = {
                        tipoIdentificacionPrincipal: val.tipo_identificacion_conductor_principal ?? '',
                        numeroIdentificacion: val.numero_identificacion ?? '',
                        primerNombrePrincipal: val.primer_nombre_conductor_principal ?? '',
                        segundoNombrePrincipal: val.segundo_nombre_conductor_principal ?? '',
                        primerApellidoPrincipal: val.primer_apellido_conductor_principal ?? '',
                        segundoApellidoPrincipal: val.segundo_apellido_conductor_principal ?? '',
                        licenciaConduccion: val.licencia_conduccion ?? '',
                        idPruebaAlcoholimetria: val.id_prueba_alcoholimetria ?? '',
                        idExamenMedico: val.id_examen_medico ?? '',
                        tipoIdentificacionSecundario: val.tipo_identificacion_conductor_secundario ?? '',
                        numeroIdentificacionSecundario: val.numero_identificacion_conductor_secundario ?? '',
                        primerNombreSecundario: val.primer_nombre_conductor_secundario ?? '',
                        segundoNombreSecundario: val.segundo_nombre_conductor_secundario ?? '',
                        primerApellidoSecundario: val.primer_apellido_conductor_secundario ?? '',
                        segundoApellidoSecundario: val.segundo_apellido_conductor_secundario ?? '',
                        licenciaConduccionSecundario: val.licencia_conduccion_secundario ?? '',
                        idPruebaAlcoholimetriaSecundario: val.id_prueba_alcoholimetria_secundario ?? '',
                        idExamenMedicoSecundario: val.id_examen_medico_secundario ?? ''
                    };
                }
            }
        }
    },
    methods: {
        async registrarConductores() {
            this.loading = true;
            const data = { ...this.form };
            console.log("Formulario enviado:", data);
            this.$emit('submit', data, 'CrearConductor');
            this.loading = false;
        }
    }
}
</script>



<style scoped>
.ruta-form {
    margin-bottom: 2rem;
}

.form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-radius: 0.5rem;
    border-left: 4px solid #ffffff;
    box-shadow: 0 2px 6px rgba(75, 72, 72, 0.37);
}

.form-title {
    margin: 0;
    font-weight: 600;
    font-size: 1.25rem;
}

.toggle-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-label-custom {
    font-weight: 600;
    margin-bottom: 0.5rem;
}



.v-select-custom {
    border-radius: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle {
    border: 2px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle:focus-within {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-submit {
    padding: 0.75rem 2rem;
    border-radius: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.card {
    border-radius: 0.75rem;
    border: none;
}
</style>
